










import Vue from "vue";
import Card from "@/components/Card/Card.vue";
import CardTitle from "@/components/Text/Card/CardTitle.vue";

export default Vue.extend({
  name: "StandartCard",
  components: { Card, CardTitle },
  props: {
    title: {
      type: String,
      default: "Default title"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    borderRadius: {
      type: String,
      default: "6px"
    }
  }
});
